import React, { useMemo } from 'react';
import { ErrorInput } from '../InputModules/Error';
import { theme, expandFontTheme, useThemeContext, } from '@contrast-security-inc/design-system-foundations';
import { css, cx } from '@emotion/css';
import { v4 as uuidv4 } from 'uuid';
import { validateInputLabelAccessibility } from '../utils/helperFunctions';
const containerStyles = (errorPlacement) => css `
  display: inline-flex;
  flex-direction: ${errorPlacement === 'right' ? 'row' : 'column'};
  position: relative;
`;
const labelColor = (isDisabled, selectedTheme) => {
    if (selectedTheme === 'dark') {
        return isDisabled ? theme.color.neutral40 : theme.color.neutral10;
    }
    return isDisabled ? theme.color.neutral60 : theme.color.neutral100;
};
const labelStyles = (hasLabel, isDisabled, font, selectedTheme) => css `
  ${expandFontTheme(theme.font[font])}
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  ${hasLabel &&
    `& span {
      margin-right: 8px;
    }`}
  color: ${labelColor(isDisabled, selectedTheme)};
  cursor: ${isDisabled ? `not-allowed;` : 'pointer;'};
`;
export const iconInputStyles = (isDisabled) => css `
  overflow: hidden;
  opacity: 0;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
  white-space: nowrap;
  cursor: ${isDisabled ? `not-allowed;` : 'pointer;'};
`;
export const iconInputErrorStyles = (errorPlacement) => css `
  align-self: ${errorPlacement === 'right' ? 'center' : 'flex-start'};
  ${errorPlacement === 'right' ? 'margin-left: 16px;' : 'margin-top: 8px;'}
`;
export const IconInputBase = React.forwardRef(({ 'aria-label': ariaLabel, children, className, error, errorPlacement = 'bottom', font = 'body', id, isDisabled = false, label, renderInput, style, testId, useInlineError = true, ...rest }, ref) => {
    validateInputLabelAccessibility('IconInputBase', label, ariaLabel);
    const { selectedTheme } = useThemeContext();
    const uniqueId = useMemo(() => id ?? uuidv4(), [id]);
    const renderError = error && useInlineError;
    return (React.createElement("div", { className: cx(containerStyles(errorPlacement), className), style: style, "data-testid": testId && `${testId}-container` },
        React.cloneElement(renderInput(), {
            ['data-testid']: testId && `${testId}-input`,
            id: uniqueId,
            ['aria-label']: ariaLabel,
        }),
        React.cloneElement(React.createElement("label", { "data-testid": testId, className: labelStyles(!!label, isDisabled, font, selectedTheme), htmlFor: uniqueId, ...rest },
            children,
            label), { ref }),
        renderError && (React.createElement("div", { className: iconInputErrorStyles(errorPlacement) },
            React.createElement(ErrorInput, { id: uniqueId, error: error, testId: testId })))));
});
IconInputBase.displayName = 'IconInputBase';
